import { render, staticRenderFns } from "./ProjectHealthchecks.vue?vue&type=template&id=1ac76716&scoped=true"
import script from "./ProjectHealthchecks.vue?vue&type=script&lang=js"
export * from "./ProjectHealthchecks.vue?vue&type=script&lang=js"
import style0 from "./ProjectHealthchecks.vue?vue&type=style&index=0&id=1ac76716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac76716",
  null
  
)

export default component.exports